import { fetchCockpit } from '@/api/business/cockpit'
import { useQuery } from '@tanstack/react-query'

export const Cockpit = {
    all: ['cockpit'] as const,
    lists: () => [...Cockpit.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...Cockpit.lists(), page, perPage, filters] as const,
    details: () => [...Cockpit.all, 'detail'] as const,
    detail: ({
        initialDate,
        finalDate,
    }: {
        initialDate: string
        finalDate: string
    }) => [...Cockpit.details(),  { initialDate, finalDate }] as const,
}

export const useCockpitQuery = (props : {initialDate: string, finalDate: string, doc: string | null}) => {
    return useQuery({
        queryFn: () => fetchCockpit({
            finalDate: props.finalDate,
            initialDate: props.initialDate,
            doc: props.doc
        }),
        queryKey: Cockpit.detail({
            finalDate: props.finalDate,
            initialDate: props.initialDate,
        }),
        refetchInterval: 240000
    })
}
